/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SuspectedTradeUserLazy_viewer$ref = any;
export type SuspectedTradeUserLazy_viewer = {
    readonly contactInfo: {
        readonly phoneNumbers: {
            readonly tradeSupport: string | null;
        } | null;
    } | null;
    readonly user?: {
        readonly verifiedTradeStatus: string | null;
    } | null;
    readonly " $refType": SuspectedTradeUserLazy_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLazy_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "contactInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "ContactInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "phoneNumbers",
          "storageKey": null,
          "args": null,
          "concreteType": "support",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "tradeSupport",
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "INTERNATIONAL"
                }
              ],
              "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "verifiedTradeStatus",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '2f1cf29c9439e50d4e2788e7de9562bc';
export default node;
